module.exports = __webpack_public_path__ + "static/NHS-Recruit-cabad8ceaa0974db1fa0685ebf3cf5b5.mp4";